import React, { useState, useEffect } from 'react';
import { useQuery } from "react-query";
import { Link, useLocation, useParams } from "react-router-dom";
import { Breadcrumb, Container, Row, Col } from 'react-bootstrap';

import Form from 'react-bootstrap/Form';

import {getItemsListBySearchQuery} from '../common/api';
import { getLanguageFullName } from '../common/functions';

import SeriesSelectPartial from '../partials/SeriesSelectPartial';
import SearchbarPartial from "../partials/SearchbarPartial";
import LoadingComponent from './LoadingComponent';
import PreSchoolEduItemsPartial from '../partials/PreSchoolEduItemsPartial';
import AllTagsListPartial from '../partials/AllTagsListPartial';

const SearchComponent = () => {

  const params = useParams();

  const [selectedTags, setSelectedTags] = useState([]);
  const [showOnlyMyLS, setShowOnlyMyLS] = useState(false);
  const [selectedSeries, setSelectedSeries] = useState([]);
  const [selectedLevels, setSelectedLevels] = useState([]);
  const [selectedVolumes, setSelectedVolumes] = useState([]);

  useEffect(() => {
    const storedShowOnlyMy = localStorage.getItem("showOnlyMy");
    setShowOnlyMyLS(storedShowOnlyMy === "true");
  }, []);

  const setSelectedSeriesHandler = (series) => {
    setSelectedSeries(series)
  }

  const setSelectedLevelsHandler = (levels) => {
    setSelectedLevels(levels)
  }

  const setSelectedVolumesHandler = (volumes) => {
    setSelectedVolumes(volumes)
  }


  const setSelectedTagsHandler = (tags) => {
    setSelectedTags(tags)
  }

  const setOnlyMyItemsSwitchHandler = () => {
    const newShowOnlyMy = !showOnlyMyLS;
    setShowOnlyMyLS(newShowOnlyMy);
    localStorage.setItem("showOnlyMy", newShowOnlyMy.toString());
  };


  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const subject = searchParams.get('subject');
  const query = searchParams.get('query');
  let view;

  const { isLoading, data, isError, isFetching, isFetched } = useQuery(
    {
        queryKey: ['searchList', subject, query],
        queryFn: () => getItemsListBySearchQuery(subject, query),
        enabled: true,
        staleTime: Infinity,
        retry: false
    }
  )

  if(isLoading || isFetching){
    view = <LoadingComponent />
  }

  if(isError){
    view = <div>Wystapił bład podczas ładowania treści</div>
  }

  if(isFetched){
   
    let items = data.data.data;
    if(showOnlyMyLS === true && Object.keys(items).length > 0){
      items = items.filter(item => item.download.status === true);
    }

    view = 
    <React.Fragment>
       <Container className="py-3">
          <Row>
            <Col sm={12} md={4} lg={4}>
              <Row className="p-3"> 
                <strong><Form.Check onChange={setOnlyMyItemsSwitchHandler} checked={showOnlyMyLS} type="switch" id="custom-switch" label="Tylko to, do czego mam dostęp" /></strong>
              </Row>
              <SeriesSelectPartial language={subject} data={items} setSelectedSeriesHandler={setSelectedSeriesHandler} setSelectedLevelsHandler={setSelectedLevelsHandler} setSelectedVolumesHandler={setSelectedVolumesHandler} showSubSelect={false}/>
              <AllTagsListPartial items={items} tags={data.data.tags} selectedSeries={selectedSeries} selectedLevels={selectedLevels}  setSelectedTagsHandler={setSelectedTagsHandler} />
            </Col>
            <Col sm={12} md={8} lg={8}>
              <Row className="p-3">
                <PreSchoolEduItemsPartial data={items} params={{language: subject}} selectedSeries={selectedSeries} selectedLevels={selectedLevels} selectedVolumes={selectedVolumes} selectedTags={selectedTags} showOnlyMy={showOnlyMyLS}/>
              </Row>
            </Col>
          </Row>
       </Container>
    </React.Fragment>
  }

  

  return(
    <React.Fragment>
      <div className="header">
        <Container className="py-3">
          
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item><Link to="/">Strona główna</Link></Breadcrumb.Item>
              <Breadcrumb.Item><Link to={"/" + subject}>{getLanguageFullName(subject)}</Link></Breadcrumb.Item>
            </Breadcrumb> 
          </Row>

          
          <Row>
            <SearchbarPartial language={subject} />
          </Row>
          
        </Container>
      </div>

      {view}

    </React.Fragment>
  )

}

export default SearchComponent;